import type { Content } from './types'

export const es: Content = {
  lang: 'es',
  hero: {
    h1: 'Tu LinkedIn te está costando clientes cada día que pasa.',
    subtitle:
      'En 3 a 5 días, lo transformo en una vitrina profesional que inspira confianza — y convierte.',
    cta: 'Hablar con Rebeca por WhatsApp',
    ctaHref:
      'https://wa.me/15148095007?text=Hola%20Rebeca%2C%20estoy%20interesado(a)%20en%20LinkedIn%20Signature',
    note: 'Respuesta garantizada en menos de 24h.',
    availability: 'Disponible en français, español & English 🌐',
  },
  problem: {
    title: 'La verdad que nadie te dice.',
    paragraphs: [
      'Tus clientes ideales te buscan en línea. Encuentran tu perfil. Y se van con otra persona.',
      'No porque no seas competente. Porque tu presencia digital no refleja tu verdadero valor.',
      'Te está costando clientes. Cada día.',
      '¿Y lo peor? Ni siquiera lo ves.',
      'Porque esos clientes — nunca te contactan.',
      'Se van con otro en silencio.',
    ],
  },
  solution: {
    title: 'Eso es exactamente lo que resuelvo.\nEn 3 a 5 días. Garantizado.',
    paragraphs: [
      'Soy Rebeca Oliveira, fundadora de Visibilia.',
      'No soy una agencia. No soy una estudiante de marketing.\nSoy una mujer de terreno — 20 años dirigiendo una empresa internacional.\n5 años construyendo la presencia digital de emprendedores y PYMEs.',
      'Trabajé de los dos lados de la mesa. Sé exactamente lo que cuesta tener una mala imagen en línea. Y lo que aporta tener una buena.',
      {
        text: 'Lo que creo para ti — es un perfil de LinkedIn que hace decir a tus clientes ideales:\n"Esta persona, le tengo confianza."',
        quote: true,
      },
    ],
    stats: [
      { value: '20 años', label: 'Dirección\ninternacional' },
      { value: '5 años', label: 'Redes\nsociales' },
      { value: '3', label: 'Idiomas\nFR·ES·EN' },
    ],
    langLine: 'FR · ES · EN 🌐',
  },
  offers: {
    title: 'Elige tu paquete.',
    popularBadge: '⭐ EL MÁS POPULAR',
    delaiLabel: '⏱ Plazo : 3 a 5 días hábiles',
    card1: {
      title: '✦ LinkedIn Signature',
      price: '497 $',
      originalValue: 'Valor real : 900 $+',
      description:
        'Tu perfil ya existe. Pero no está trabajando para ti. Eso lo cambiamos.',
      features: [
        'Auditoría completa de tu perfil actual',
        'Título estratégico que posiciona',
        'Banner profesional personalizado',
        'Sección Acerca de que convierte',
        'Experiencia reestructurada y valorizada',
        'Sección servicios configurada',
        'URL personalizada',
        '1 publicación de lanzamiento lista para publicar',
        'Mini-guía de uso de LinkedIn',
        'Llamada de entrega personalizada (15 min)',
      ],
      cta: 'Quiero transformar mi LinkedIn',
      ctaHref:
        'https://wa.me/15148095007?text=Hola%20Rebeca%2C%20quiero%20el%20paquete%20LinkedIn%20Signature%20a%20497%24',
    },
    card2: {
      title: '✦ LinkedIn Creación',
      price: '297 $',
      description:
        'Aún no tienes perfil. O está vacío desde hace años. Empezamos de cero — y lo hacemos bien.',
      features: [
        'Creación completa del perfil',
        'Banner profesional personalizado',
        'Título + bio estratégicos',
        'Sección servicios configurada',
        'URL personalizada',
        '1 publicación de lanzamiento lista para publicar',
        'Mini-guía de uso de LinkedIn',
      ],
      cta: 'Quiero crear mi LinkedIn',
      ctaHref:
        'https://wa.me/15148095007?text=Hola%20Rebeca%2C%20quiero%20el%20paquete%20LinkedIn%20Creaci%C3%B3n%20a%20297%24',
    },
    helperText:
      '¿No sabes cuál te conviene? Escríbeme — te guío en 5 minutos. ✦',
  },
  faq: {
    title: 'Preguntas frecuentes.',
    items: [
      {
        q: '¿Necesito estar disponible durante el proceso?',
        a: 'No. Llenas un formulario en 10 minutos. Yo me encargo del resto.\nRecibes tu perfil en 3 a 5 días. Eso es todo.',
      },
      {
        q: '¿Cómo funciona el pago?',
        a: 'Transferencia bancaria, PayPal o tarjeta de crédito. Tú eliges. Sin sorpresas.',
      },
      {
        q: '¿Cuál es el proceso exacto?',
        a: '1. Me escribes por WhatsApp\n2. Te envío un formulario (10 min)\n3. Creo tu perfil\n4. Revisas y apruebas\n5. Llamada de entrega (15 min)\nSimple. Rápido. Eficaz.',
      },
      {
        q: '¿Es LinkedIn importante para mi tipo de negocio?',
        a: 'Si tus clientes, socios o empleadores buscan profesionales en línea —\nsí, absolutamente. LinkedIn es la primera plataforma de credibilidad profesional del mundo.',
      },
      {
        q: '¿Y si no estoy satisfecho?',
        a: 'Revisamos juntos hasta que tu perfil te represente perfectamente.\nTu satisfacción es mi prioridad. ✦',
      },
    ],
  },
  finalCta: {
    title: 'Tu LinkedIn puede empezar a trabajar para ti esta misma semana.',
    subtitle:
      '3 a 5 días. Un perfil profesional, estratégico, que refleja por fin tu verdadero valor.',
    cta: 'Escribir a Rebeca por WhatsApp',
    ctaHref:
      'https://wa.me/15148095007?text=Hola%20Rebeca%2C%20estoy%20listo(a)%20para%20transformar%20mi%20LinkedIn',
    note: 'Sin compromiso. Solo una conversación. Respondo en menos de 24h. ✦',
    closing:
      'Trabajaste duro para construir tu experiencia. Es hora de que tu LinkedIn lo muestre. ✦',
  },
}
